import React from "react";
import styles from "./Note.module.scss";

const Note = ({ children, style = {}, ...rest }) => (
  <div className={styles.note} style={style} {...rest}>
    <p className={styles.text}>{children}</p>
  </div>
);

export default Note;
